import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { Location } from '@angular/common';

import { Observable, Subscription } from 'rxjs';
import { filter, first } from 'rxjs/operators';

import { select, Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import * as fromAuth from 'app/auth/store';

import { MatSnackBar } from '@angular/material/snack-bar';

import { ConnectionResolver, UserPermissionsService } from 'app/core/services';
import { FeatureFlagService } from '../../../../views/settings/feature-flag/services/feature-flag.service';

@Component({
  selector: 'ebo-admin-layout',
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  hasValidRoute = false;
  isOnDashboard = false;

  public environment$: Observable<string>;
  isBotCreated$: Observable<boolean>;
  private isBotCreatedSub: Subscription;
  private websocketSub: Subscription;
  private featureFlagSubscription: Subscription;

  constructor(
    private location: Location,
    private router: Router,
    private connectionResolver: ConnectionResolver,
    private store: Store<fromRoot.AppState>,
    private featureFlagService: FeatureFlagService,
    private userPermissionsService: UserPermissionsService,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit() {
    this.environment$ = this.store.pipe(select(fromAuth.getEnvironment));
    this.isBotCreated$ = this.store.pipe(select(fromAuth.isBotCreated));
    this.isBotCreatedSub = this.store.pipe(select(fromAuth.isBotCreated)).subscribe(isExists => {
      if (isExists === false && this.router.url !== '/virtual-agents/create') {
        this.router.navigateByUrl('/virtual-agents/create');
      }
    });

    this.checkIsDashboard();

    this.websocketSub = this.store
      .pipe(select(fromAuth.getToken))
      .pipe(
        filter(token => token != null),
        first()
      )
      .subscribe(token => {
        this.connectionResolver.startconnection(token);
      });

    this.router.events.subscribe(event => {
      if (this.location.path() !== '') {
        this.hasValidRoute = !this.location.path().includes('/chat');
      }

      this.checkIsDashboard();

      if (event instanceof NavigationError) {
        if (event?.error?.statusCode === 403) {
          this.snackbar.open("You don't have access to this page", 'Dismiss');
        }
      }
    });

    this.getFeatureFlags();
    this.userPermissionsService.setPermissions(JSON.parse(sessionStorage.getItem('userObject'))?.permissions);
  }

  checkIsDashboard(): void {
    this.isOnDashboard = this.location.path().includes('/dashboard');
  }

  getFeatureFlags(): void {
    this.featureFlagSubscription = this.featureFlagService.getFeatureFlags().subscribe(res => {
      sessionStorage.setItem('featureFlags', JSON.stringify(res));
      this.featureFlagService.changeFeatureFlags(res);
    });
  }

  ngOnDestroy(): void {
    if (this.websocketSub) {
      this.connectionResolver.closeHub();
      this.websocketSub.unsubscribe();
    }
    if (this.featureFlagSubscription) {
      this.featureFlagSubscription.unsubscribe();
    }
  }
}
